<template>
  <div id="home">
    <div class="content" v-loading="loading">
      <h1>
        <div class="pc">CaseHistory > <span>Chart No.{{info.chartNo}}</span></div>
        <div class="pc">
          <el-button style="border-color:#034844;padding:6px 20px;color:#034844;" @click="back">Back</el-button>
          <el-button type="primary" @click="edit" style="background-color: #034844;border-color:#034844;padding:6px 20px;">Save</el-button>
          <el-button type="primary" @click="share" style="background-color: #034844;border-color:#034844;padding:6px 20px;">Share</el-button>
        </div>
        <div class="mobile">
          <div style="border-bottom:1px solid #ededed;display: flex;align-items: center;width: 100vw;padding:0 20px;position: fixed;background-color: #ffffff;top:70px;left:0;height:70px;">
            <i class="el-icon-arrow-left" @click="back"></i>
            <div style="width: 100%;text-align: center;font-size: 14px;">CaseHistory ><span>Chart No.{{info.chartNo}}</span></div>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><a @click.stop="edit" style="padding:0 20px;"><i class="font-size-16 el-icon-wallet"></i>Save</a></el-dropdown-item>
                <el-dropdown-item><a @click.stop="share" style="padding:0 20px;"><i class="font-size-16 el-icon-share"></i>Share</a></el-dropdown-item>
                <el-dropdown-item><a @click.stop="downloadImage" style="padding:0 20px;"><i class="font-size-16 el-icon-download"></i>Download</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </h1>
      <div class="mainDiv">
        <div class="imgMain">
          <div class="div">
            <div class="img" :style="'background-image:url('+(info.status == 'S3' ? getImgS3(info.oldImage) : getImg(info.oldImage))+');'"></div>
            <span>Original</span>
          </div>
          <div class="div">
            <div class="img" :style="'background-image:url('+(info.statusNew == 'S3' ? getImgS3(info.newImage) : getImg(info.newImage))+');'">
              <div class="img" v-if="info.teethWhitening == 1" :style="'filter: brightness('+(info.brightness / 50)+') saturate('+(info.saturate / 50)+')  contrast('+(info.contrast / 50)+');border:none;background-image:url('+(info.statusNew == 'S3' ? getImgS3(info.newImageMask) : getImg(info.newImageMask))+');'">
              </div>
            </div>
            <span>Currently selected</span>
          </div>
        </div>
        <div class="imgMain" v-if="info.teethWhitening == 1" style="margin-top:20px;">
          <div style="width: 100%;"></div>
          <div style="width: 100%;">
            <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">brightness:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="info.brightness"></el-slider></div>
            <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">saturate:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="info.saturate"></el-slider></div>
            <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">contrast:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="info.contrast"></el-slider></div>
          </div>
        </div>
        <div class="swiper" v-if="info.results">
          <swiper class="list pc" :options="swiperOption" ref="mySwiper" :class="info.results.length < 5 ? 'cent' : ''">
            <swiper-slide v-for="item,index in info.results" :key="index">
              <div class="item" :style="'background-image:url('+(item.status == 'S3' ? getImgS3(item.image) : getImg(item.image))+');'" @click="changeNewImage(item)" :class="item.id == info.newImageId ? 'act' : ''"></div>
            </swiper-slide>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
          </swiper>
          <swiper class="list mobile" :options="swiperOptionMobile" ref="mySwiper">
            <swiper-slide v-for="item,index in info.results" :key="index">
              <div class="item" :style="'background-image:url('+(item.status == 'S3' ? getImgS3(item.image) : getImg(item.image))+');'" @click="changeNewImage(item)" :class="item.id == info.newImageId ? 'act' : ''"></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <edit ref="editForm"></edit>
      <share ref="shareForm"></share>

      <div ref="imgUrl" style="font-size: 0;position: absolute;left:-2000px;">
        <div style="font-size: 0;background-size: cover;background-position: center;" :style="'background-image:url('+(info.statusNew == 'S3' ? getImgS3(info.newImage) : getImg(info.newImage))+');'">
          <canvas ref="canvas" width="500" height="300" style="background-color: transparent;"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction } from '@/network/manage';
  import Edit from './orthodonticSmile/Edit'
  import Share from './orthodonticSmile/Share'
  import { swiper, swiperSlide } from "vue-awesome-swiper"
  import 'swiper/css/swiper.css'
  import html2canvas from 'html2canvas'
  export default {
    name: 'OrthodonticSmileShow',
    components: {
      Edit,swiper,swiperSlide,Share
    },
    data() {
      return {
        swiperOption:{
          slidesPerView: 5,
          spaceBetween: 10,
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        swiperOptionMobile:{
          slidesPerView: 3,
          spaceBetween: 10,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        },
        swiperIndex:1,
        value:50,
        info:'',
        newImage:'',
        oldImage:'',
        loading:false
      }
    },
    computed: {

    },
    created(){
      this.loading = true
      const that = this
      getAction('/admin/caseHistory/queryById?id='+this.$route.query.id).then((res) => {
        if(res.success){
          this.info = res.result
          for(let i = 0; i < this.info.results.length; i++){
            if(this.info.results[i].id == this.info.newImageId){
              this.$set(this.info,'newImageMask',this.info.results[i].imageMask);
            }
          }
          if(this.info.teethWhitening == 1){
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const imageMask = new Image();
            imageMask.crossOrigin = "anonymous";
            imageMask.src = (this.info.statusNew == 'S3' ? this.getImgS3(this.info.newImageMask) : this.getImg(this.info.newImageMask))
            imageMask.onload = () => {
              canvas.width = imageMask.width
              canvas.height = imageMask.height
              ctx.drawImage(imageMask, 0, 0, canvas.width, canvas.height);
              that.adjustCanvas(canvas,that.info.brightness/50,that.info.contrast/50,that.info.saturate/50)
            };
          }else{
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            const image = new Image();
            image.crossOrigin = "anonymous";
            image.src = (this.info.statusNew == 'S3' ? this.getImgS3(this.info.newImage) : this.getImg(this.info.newImage))
            image.onload = () => {
              canvas.width = image.width
              canvas.height = image.height
              ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            };
          }
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.message);
      }).finally((res) => {
        this.loading = false
      });
    },
    methods:{
      adjustCanvas(canvas, brightness, contrast, saturation) {
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            // RGBA格式，i表示当前像素的索引，i+1, i+2, i+3分别是红、绿、蓝和透明度值
            let r = data[i];
            let g = data[i + 1];
            let b = data[i + 2];
            let a = data[i + 3];

            // 调整亮度
            r *= brightness;
            g *= brightness;
            b *= brightness;
             // 调整对比度
            r = ((data[i] - 128) * contrast) + 128;
            g = ((data[i + 1] - 128) * contrast) + 128;
            b = ((data[i + 2] - 128) * contrast) + 128;
            // 调整饱和度
            const max = Math.max(r, g, b);
            r = max + saturation * (r - max);
            g = max + saturation * (g - max);
            b = max + saturation * (b - max);

            // 确保RGB值在0到255之间
            data[i] = r > 255 ? 255 : r < 0 ? 0 : r;
            data[i + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
            data[i + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
        }
        ctx.putImageData(imageData, 0, 0);
      },
      getImgS3(key) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
      },
      getImg(path) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/view/' + path
      },
      edit() {
        this.$refs.editForm.init(this.info.id,this.info.newImageId,this.info.brightness,this.info.saturate,this.info.contrast)
      },
      share() {
        this.$refs.shareForm.init(this.info.id)
      },
      changeNewImage(item){
        this.$set(this.info,'statusNew',item.status);
        this.$set(this.info,'newImageId',item.id);
        this.$set(this.info,'newImage',item.image);
        for(let i = 0; i < this.info.results.length; i++){
          if(this.info.results[i].id == this.info.newImageId){
            this.$set(this.info,'newImageMask',this.info.results[i].imageMask);
          }
        }
      },
      back() {
        this.$router.back(1)
      },
      downloadImage(){
        const element = this.$refs.imgUrl;
        html2canvas(element,{useCORS:true}).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = imgData;
          link.download = 'image.png';
          link.click();
        });
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;}
  .demoImg2{background-image: url(../assets/imgs/imgDemo2.png);}
  .demoImg{background-image: url(../assets/imgs/imgDemo.png);}
  .mainDiv{padding:20px;width: 100%;display: flex;align-items: center;flex-direction: column;}
  .content{background-color: #ffffff;border-radius: 12px;display: flex;flex-direction: column;width: 100%;align-items: center;margin:0 auto;}
  h1{border-bottom: 1px solid #D9D9D9;height: 60px;display: flex;align-items: center;width: 100%;padding:0 20px;font-size: 16px;justify-content: space-between;}
  h1 span{font-weight: normal;margin-left:10px;}
  .mobile{display: none;}
  .bg{background-size: auto 100%;background-position: center;background-repeat: no-repeat;width: 100%;}
  .picOld{overflow: hidden;border-right: 2px solid #ffffff;}
  .slider{width: 800px;position: absolute;margin-top:calc((100vh - 120px) / 2 )}
  .picOldImg{height:calc(100vh - 180px);width: 800px;background-size: auto 100%;background-position: center;background-repeat: no-repeat;}
  .btn{padding:20px 0;display: flex;width: 80%;margin: 0 auto;}
  .btn div{width: 100%;display: flex;justify-content: center;}
  .btn div span{width: 200px;height: 45px;display: flex;justify-content: center;align-items: center;border-radius: 7px;font-size: 20px;}
  .btn div:last-child span{border:1px solid #8BB2B2;background-color: #9ABDBD;color:#ffffff;}
  .imgMain{width: 860px;display: flex;align-items: center;}
  .imgMain .div{width: 100%;display: flex;flex-direction: column;align-items: center;cursor: default !important;}
  .imgMain .div:first-child{margin-right: 1px;}
  .imgMain .div .img{height: 460px;width: 100%;background-size: cover;background-position: center center;}
  .imgMain .div span{width: 250px;height: 44px;border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-top:10px;}
  .imgMain .div:first-child span{border:1px solid #BCBEC0;color: #979797;}
  .imgMain .div:last-child span{border:1px solid #8BB2B2;color: #ffffff;background-color: #8BB2B2;}
  .swiper{display: flex;align-items: center;margin:30px 0;}
  .swiper span{border:1px solid #D9D9D9;width: 20px;height: 20px;cursor: pointer;display: flex;align-items:center;justify-content: center;font-size: 12px;color: #D9D9D9;margin: 0 10px;border-radius: 4px;}
  .swiper .list{width: 730px;overflow: hidden;height:180px;}
  .swiper .list .item{opacity: 0.7;cursor: pointer;height: 180px;background-size: cover;border:1px solid #D9D9D9;border-radius: 4px;overflow: hidden;flex-shrink: 0;background-position: center;}
  .swiper .list .act{opacity: 1;border:5px solid #8BB2B2;}
  .swiper-button-prev{transform:scale(0.6);margin-top:-20px;}
  .swiper-button-next{transform:scale(0.6);margin-top:-20px;}
  >>>.cent .swiper-wrapper{justify-content: center;}

  @media (max-width: 768px) {
    #home{padding:0;}
    h1{flex-direction: column;padding:20px 0;height: auto;}
    h1 div:first-child{margin-bottom:10px;}
    .pc{display: none;}
    .mobile{display: inherit;}
    .imgMain{width: 100%;flex-direction: column;margin-top:20px;}
    .imgMain .div:first-child{margin-right: 0;}
    .content{border-radius: 0;width: 100vw;min-height: 100vh;justify-content: flex-start;}
    .div{display: flex;flex-direction: column;}
    .imgMain .div span{margin-bottom:10px;}
    .slider{width:calc(100vw - 40px);margin-top:80vw;}
    .bg{margin-top:20px;width:calc(100vw - 40px);}
    .picOldImg{width:calc(100vw - 40px);height: 120vw;}
    .btn{width: 100%;}
    .btn div span{width: 150px;font-size: 14px;}
    .swiper{width:calc(100vw - 40px);margin-bottom:0;}
    .swiper .list{width:calc(100vw - 40px);}
    .swiper .list .item{height:150px;}
    >>>.cent .swiper-wrapper{justify-content: flex-start;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .imgMain{width: 100%;}
    .slider{width:calc(100vw - 170px);}
    .picOldImg{width:calc(100vw - 170px);}
    #home{padding:20px;}
    .swiper{width:calc(100vw - 90px - 80px);}
    .swiper .list{width:calc(100vw - 90px - 80px);}
    >>>.cent .swiper-wrapper{justify-content: center;}
  }
</style>
